import React, {useRef, useMemo, useEffect} from 'react'
import moment from 'moment'
import _ from 'lodash'

import {IconButton, Popover} from '@material-ui/core'
import './Month.scss'

const TimeList = ({disableDatesBefore, date, selectedDate, defaultIndex, onClickTime}) => {
  const refList = useRef(null)

  const disableDatesBeforeUnix = useMemo(() => {
    if (!disableDatesBefore) return 0
    return disableDatesBefore.unix()
  }, [disableDatesBefore])

  const times = useMemo(() => {
    // set times
    const _date = date.clone().startOf('day')
    let times = []

    for (let i = 0; i < 48; i++) {
      const _n = _date.clone().add('minutes', i * 30)
      times.push(_n)
    }
    return times
  }, [date])

  // update scrollbar
  useEffect(() => {
    const index = times.findIndex(f => f.valueOf() === date.valueOf())
    const rect = refList.current.getBoundingClientRect()
    refList.current.scrollTop = index * 24 - rect.height * 0.75
    window.test = refList.current
  }, [times, date, refList])

  return (
    <div ref={refList} className="c-res-mod ap-list  ap-scrollbar">
      <div className="ap-list__wrapper">
        {times.map((t, i) => (
          <div
            key={i}
            className={`ap-list__item ap-typography ap-flex ap-flex--end ${
              t.unix() <= disableDatesBeforeUnix ? 'ap-list__item--disabled' : ''
            }  ${date.valueOf() === t.valueOf() ? 'ap-list__item--selected' : ''}`}
            style={{alignItems: 'center', cursor: 'pointer'}}
            onClick={e => onClickTime(e, t)}
          >
            {t.format('hh:mm')}
            <span
              style={{marginLeft: 6}}
              className="ap-typography ap-typography--sm ap-typography--gray"
            >
              {t.format('a')}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default TimeList
